import app from 'flarum/common/app';

/**
 * Time left on a turn, formatted via locale (e.g. "5h 12m"), null if expired or unset.
 * Shared by CardSlider (own turn) and ArenaBattleNextTurnPost (opponent's turn).
 */
export default function formatTimeLeft(expiresAt) {
  if (!expiresAt) return null;
  const ms = new Date(expiresAt).getTime() - Date.now();
  if (ms <= 0) return null;
  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const key = hours > 0 ? 'forumaker-arena.forum.card_slider.time_hours' : 'forumaker-arena.forum.card_slider.time_minutes';
  const translated = app.translator.trans(key, {
    hours,
    minutes
  });
  return Array.isArray(translated) ? translated.join('') : String(translated);
}
flarum.reg.add('forumaker-arena', 'common/helpers/formatTimeLeft', formatTimeLeft);